import { NySession } from '@nybble/nyreact';
import React from 'react';
import DeviceIndex from '.';

const ProjectDevicesList = () => {
    return <DeviceIndex tableIndex="tableIndex.devices" project={NySession.getProjectInfo()} />;
};

export default ProjectDevicesList;
